import { MAP_API_KEY } from 'config';
import { useEffect, useState } from 'react';

const useAbsentAlertData = (addressFilter, map, data) => {
  const [geocodedAddress, setGeocodedAddress] = useState(null);

  // Geocode address when there's an addressFilter but no data
  useEffect(() => {
    if (!addressFilter?.label || !map || data?.length > 0) {
      setGeocodedAddress(null);
      return;
    }

    // Only geocode if we don't already have a geocoded address for this filter
    if (geocodedAddress?.addressLabel === addressFilter.label) {
      return;
    }

    if (!window.google?.maps?.Geocoder) {
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: addressFilter.label }, (results, status) => {
      if (status === 'OK' && results && results.length > 0) {
        const { lat, lng } = results[0].geometry.location;
        setGeocodedAddress({
          lat: lat(),
          lng: lng(),
          addressLabel: addressFilter.label
        });
      } else {
        console.error('Geocoding failed:', status);
        setGeocodedAddress(null);
      }
    });
  }, [addressFilter?.label, MAP_API_KEY, data?.length]);

  return [geocodedAddress, setGeocodedAddress];
};

export default useAbsentAlertData;
